export const basePath = 'https://praktik-home.ru/';
export const apiPath = basePath + 'api';
// export const projectPath = 'https://dealer.safe.ak.dev3.nowmedia.ru/3/api/getProject';
export const projectPath = 'api/getProject';
